export const isMobile = () => window.matchMedia('(max-width: 912px)').matches;
